var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "thenavbar" }, [
    _c(
      "div",
      { staticClass: "logo-container", on: { click: _vm.toIndex } },
      [_c("SVGMetallProfil")],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "navbar-text-container" }, [
      _c("span", { staticClass: "mh-10 white-text" }, [
        _vm._v("Мы можем Вам помочь!")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "mh-10 white-text bold-text" }, [
        _vm._v("8 800 100-10-01")
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "mh-10 white-text link-underline",
          on: { click: _vm.openModalFeedback }
        },
        [_vm._v("Перезвоните мне")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }